import {Component, EventEmitter, Input, OnDestroy, Output} from '@angular/core';
import {Subject} from 'rxjs';

@Component({
  selector: 'app-chart-pag',
  templateUrl: './chart-pag.component.html',
  styleUrls: ['./chart-pag.component.scss']
})

export class ChartPagComponent implements OnDestroy {

  @Input() pages: string[] = [];
  @Output() idx = new EventEmitter<number>();

  pagIdx = 0;

  private onDestroy$: Subject<void> = new Subject<void>();

  constructor() {
  }

  ngOnDestroy() {
    this.onDestroy$.next();
  }

  // ********************************************************************************************************
  // LOAD DATA
  // ********************************************************************************************************

  // ********************************************************************************************************
  // PROCESS DATA
  // ********************************************************************************************************

  // ********************************************************************************************************
  // UI
  // ********************************************************************************************************

  goToSlide(idx: number): void {
    this.pagIdx = idx;
    this.emit();
  }

  goToPrevSlide(): void {
    this.pagIdx = Math.max(this.pagIdx -= 1, 0);
    this.emit();
  }

  goToNextSlide(): void {
    this.pagIdx = Math.min(this.pagIdx += 1, this.pages.length - 1);
    this.emit();
  }

  private emit(): void {
    this.idx.emit(this.pagIdx);
  }

}
